

<template>

    <div>        
        <v-card>
            <v-card-title>
                <h2>
                    Personal Access Tokens
                </h2>
                                
            </v-card-title>

            <v-card-text>
                
                <v-layout row>
                    <v-flex xs12>
                        <v-btn v-on:click.native.stop="showCreateTokenForm">
                            Create New Token
                        </v-btn>
                    </v-flex>
                </v-layout>
                 <!-- No Tokens Notice -->
                <v-layout row>
                    <v-flex xs12>
                        <p class="mb-0 mt-2" v-if="tokens.length === 0">
                            You have not created any personal access tokens.
                        </p>
                    </v-flex>
                </v-layout>
                
                <v-layout>
                    <v-flex xs6 offset-xs6>
                        <v-text-field
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                            v-model="tsearch"
                            >

                        </v-text-field>
                    </v-flex>
                </v-layout>
                <!-- Personal Access Tokens -->
                <v-data-table 
                    v-if="tokens.length > 0"                   
                    v-bind:headers="headers"
                    v-bind:items="tokens"
                    v-bind:search="tsearch"
                    select-all
                    v-bind:pagination.sync="pagination"
                    item-key="name"
                    class="elevation-0"
                    >
                
                    <template slot="headers" slot-scope="props">
                   
                        <tr>                            
                            
                            <th 
                                align="left"
                                v-for="header in props.headers" 
                                :key="header.text"
                                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                @click="changeSort(header.value)"
                            >
                            <v-icon>arrow_upward</v-icon>
                                {{ header.text }}
                            </th>
                            <th></th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr>                                                       
                            
                            <td>
                                {{ props.item.name }}
                            </td>

                            
                            <td>
                                <v-btn small class="error" v-on:click.native.stop="revoke(props.item)">
                                    Delete
                                </v-btn>
                            </td>
                        </tr>
                    </template>                   
                </v-data-table>
            </v-card-text>
        </v-card>
        
        
        <v-dialog v-model="dialog1" lazy absolute>            
            <v-card>
                <v-card-title>
                    <div class="headline">Create Token</div>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-layout row v-for="error in form.errors" :key="error.id">
                            <v-flex xs12>
                                {{ error }}
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    hint="Something your users will recognize and trust."
                                    id="create-token-name"
                                    v-model="form.name">

                                </v-text-field>                                                        
                            </v-flex>
                        </v-layout>
                        <v-layout row v-if="scopes.length > 0">
                            <h4> Scopes </h4>
                            <v-flex xs12>
                                <v-switch
                                    :label="scope.id"
                                    name="redirect"                           
                                    id="create-client-redirect"
                                    @click="toggleScope(scope.id)"
                                    :checked="scopeIsAssigned(scope.id)">
                                    dark
                                    ></v-switch>

                                </v-text-field>                                                        
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="green--text darken-1" flat="flat" v-on:click.native.stop="dialog1 = false">Close</v-btn>
                    <v-btn class="green--text darken-1" flat="flat" v-on:click.native.stop="store">Create</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog2" lazy absolute>            
            <v-card>
                <v-card-title>
                    <div class="headline">Personal Access Token</div>
                </v-card-title>
                <v-card-text>
                    <p>
                        Here is your new personal access token. This is the only time it will be shown so don't lose it!
                        You may now use this token to make API requests.
                    </p>

                    <pre><code>{{ accessToken }}</code></pre>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="green--text darken-1" flat="flat" v-on:click.native.stop="dialog2 = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

       
    </div>
    
</template>

<script>

    export default {
        /*
         * The component's data.
         */
        data() {
            return {
                pagination: {
                sortBy: 'name'
                },
                tsearch:'',
                headers: [
                    {text: 'Name', align: 'left', value: 'name'},
                ],
                accessToken: null,

                tokens: [],
                scopes: [],
                dialog1: false,
                dialog2: false,

                form: {
                    name: '',
                    scopes: [],
                    errors: []
                }
            };
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            
            changeSort (column) {
                if (this.pagination.sortBy === column) {
                  this.pagination.descending = !this.pagination.descending
                } else {
                  this.pagination.sortBy = column
                  this.pagination.descending = false
                }              
            },
            /**
             * Prepare the component.
             */
            prepareComponent() {
                this.getTokens();
                this.getScopes();

            },

            /**
             * Get all of the personal access tokens for the user.
             */
            getTokens() {
                this.$store.dispatch('getPersonalTokens').then((response)=>{ 
                    this.tokens = response.data;
                })               
            },

            /**
             * Get all of the available scopes.
             */
            getScopes() {
                this.$store.dispatch('getScopes').then((response)=>{ 
                    this.scopes = response.data;
                })                 
            },

            /**
             * Show the form for creating new tokens.
             */
            showCreateTokenForm() {
                this.dialog1=true;
            },

            /**
             * Create a new personal access token.
             */
            store() {
                this.accessToken = null;

                this.form.errors = [];

                this.$store.dispatch('postPersonalTokens', this.form).then((response)=>{ 
                    this.form.name = '';
                    this.form.scopes = [];
                    this.form.errors = [];
                    this.tokens.push(response.data.token);
                    this.showAccessToken(response.data.accessToken);
                })    
                
            },

            /**
             * Toggle the given scope in the list of assigned scopes.
             */
            toggleScope(scope) {
                if (this.scopeIsAssigned(scope)) {
                    this.form.scopes = _.reject(this.form.scopes, s => s == scope);
                } else {
                    this.form.scopes.push(scope);
                }
            },

            /**
             * Determine if the given scope has been assigned to the token.
             */
            scopeIsAssigned(scope) {
                return _.indexOf(this.form.scopes, scope) >= 0;
            },

            /**
             * Show the given access token to the user.
             */
            showAccessToken(accessToken) {
                this.dialog1=false;

                this.accessToken = accessToken;

                this.dialog2=true;
            },

            /**
             * Revoke the given token.
             */
            revoke(token) {
                this.$store.dispatch('destroyPersonalTokens', token.id).then((response)=>{ 
                    this.getTokens();
                })                 
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PersonalAccessTokens.vue?73014986